import React from 'react';
import { SearchActionTypes, ListingActionTypes } from '@state/features/common.types';
import { useDispatch, useSelector } from 'react-redux';
import analytics from '@stone/utils/analytics';
// import analytics from '@utils/analytics';
import Checkbox from '@stone/ui/formfields/Checkbox';
import Button from '@ui/button/Button';
const ProductFilterValue = (props) => {
    const { inSearch } = useSelector((state) => state.search);
    const dispatch = useDispatch();
    const getRefinementType = () => {
        return inSearch ? SearchActionTypes.UPDATE_SEARCH_REFINEMENT : ListingActionTypes.UPDATE_LISTING_REFINEMENT;
    };
    const addSubcategoryFilter = (valueId) => {
        dispatch({
            type: ListingActionTypes.FETCH_LISTING,
            payload: {
                resultsType: 'INIT',
                cgid: valueId,
            },
        });
    };
    const addFilterValue = (filterId, valueId) => {
        dispatch({
            type: getRefinementType(),
            payload: {
                filterAction: props.replaceFilter ? 'REPLACE' : 'ADD',
                filterId,
                valueId,
            },
        });
    };
    const label = () => {
        return props.customLabel ? (props.customLabel) : props.refinementValue.type === 'color' ? (React.createElement(React.Fragment, null,
            React.createElement("span", { className: `swatch swatch--filter swatch--${props.refinementValue.presentationId}` }),
            props.refinementValue.displayValue)) : (props.refinementValue.displayValue);
    };
    const value = () => {
        return (props.refinement.isPriceRefinement && `${props.refinementValue.valueFrom || 0}-${props.refinementValue.valueTo}`) || props.refinementValue.displayValue;
    };
    const hiddenLinks = () => {
        return (props.refinementValue.link && (React.createElement("a", { className: "d-none", href: props.refinementValue.link }, props.refinementValue.displayValue)));
    };
    switch (props.type) {
        case 'button':
            return (React.createElement(Button, { cls: ['button--link'], className: props.className, type: "button", ariaExpanded: props.refinementValue.selected, disabled: !props.refinementValue.selectable, onClick: () => {
                    analytics.refinementClick('filter', `${props.refinement.attributeID}-${props.refinementValue.presentationId}`);
                    if (!props.refinement.isCategoryRefinement) {
                        addFilterValue(props.refinement.attributeID, value());
                    }
                    else {
                        addSubcategoryFilter(props.refinementValue.id);
                    }
                } },
                React.createElement(React.Fragment, null, props.children || label())));
        default:
            return (React.createElement("li", { className: "subnav-filter__value" },
                React.createElement(Checkbox, { type: (props.type === 'radio' && 'radio') || 'checkbox', name: props.name || (props.type === 'radio' && props.refinement.attributeID && `${props.refinement.attributeID}-name`) || props.refinementValue.id, value: value(), id: `${props.refinementValue.id}-${props.refinementValue.presentationId || 'field'}-${props.index}`, onFocus: props.onFocus, onChange: () => {
                        if (props.refinementValue.selectable) {
                            analytics.refinementClick('filter', `${props.refinement.attributeID}-${props.refinementValue.presentationId}`);
                            if (!props.refinement.isCategoryRefinement) {
                                addFilterValue(props.refinement.attributeID, value());
                            }
                            else {
                                addSubcategoryFilter(props.refinementValue.id);
                            }
                        }
                    }, checked: props.refinementValue.selected, disabled: !props.refinementValue.selectable, className: props.className, labelAriaHidden: true }, props.children || label()),
                hiddenLinks()));
    }
};
export default ProductFilterValue;
